export default __webpack_public_path__ + "static/media/logo-small.93ad5184.svg";